<div class="pt-3" *ngIf="templateNotFound">
  <h2>Template Not Found</h2>
</div>

<div class="pt-3" *ngIf="serverError !== null">
  <h2>Server Error: {{ serverError }}</h2>
</div>

<div class="pt-3" *ngIf="!documentTemplate && loadingTemplate">
  <h2>Loading...</h2>
</div>

<div *ngIf="!templateNotFound && (serverError === null) && documentTemplate">
  <nav class="navbar navbar-expand navbar-light bg-light capitan-sub-nav">
    <ul class="navbar-nav">
      <li class="nav-item">
        <a routerLink="/document-templates" class="nav-link arrow-link">&#8592;</a>
      </li>
    </ul>

    <ul class="navbar-nav mx-auto">
      <li class="nav-item">
        <a class="nav-link" href="#"
           [class.active]="currentEditMode === EditModes.settings"
           [class.disabled]="loadingTemplate" [class.text-muted]="loadingTemplate"
           (click)="changeEditMode(EditModes.settings);$event.preventDefault();">
          Settings
        </a>
      </li>
      <li class="nav-item">
        <a class="nav-link" href="#"
           [class.active]="currentEditMode === EditModes.sections"
           [class.disabled]="loadingTemplate" [class.text-muted]="loadingTemplate"
           (click)="changeEditMode(EditModes.sections);$event.preventDefault();">
          Content
        </a>
      </li>
      <li class="nav-item">
        <a class="nav-link" href="#"
           [class.active]="currentEditMode === EditModes.linkedProducts"
           [class.disabled]="loadingTemplate" [class.text-muted]="loadingTemplate"
           (click)="changeEditMode(EditModes.linkedProducts);$event.preventDefault();">
          Linked Products
        </a>
      </li>
    </ul>

    <form class="form-inline">
      <div *ngIf="!documentTemplate.is_removed" class="mr-2"
           [ngbTooltip]="unsavedChanges ? 'Your document template has unsaved changes. Save the changes or refresh the page before retiring it.' : null">
        <button class="btn btn-danger btn-sm"
                [class.disabled]="loadingTemplate || unsavedChanges"
                [disabled]="loadingTemplate || unsavedChanges"
                type="button" (click)="handleRetire()">
          Retire
        </button>
      </div>

      <div *ngIf="documentTemplate.is_removed" class="mr-2"
           [ngbTooltip]="unsavedChanges ? 'Your document template has unsaved changes. Save the changes or refresh the page before restoring it.' : null">
        <button class="btn btn-success btn-sm"
                [class.disabled]="loadingTemplate || unsavedChanges"
                [disabled]="loadingTemplate || unsavedChanges"
                type="button" (click)="handleRestore()">
          Restore
        </button>
      </div>

      <div *ngIf="!documentTemplate.is_removed"
           [ngbTooltip]="unsavedChanges ? 'Your document template has unsaved changes. Either save the changes or refresh the page in order to open the preview.' : null">
        <a class="btn btn-outline-primary btn-sm preview-btn"
           [class.disabled]="unsavedChanges"
           (click)="unsavedChanges ? $event.preventDefault() : null"
           [href]="documentTemplate.climber_app_url" target="_blank">
          Preview
        </a>
      </div>
      <button class="btn btn-primary btn-sm ml-2"
              [class.disabled]="loadingTemplate" [disabled]="loadingTemplate"
              type="button" (click)="handleSave()">
        Save
      </button>
    </form>
  </nav>

  <app-document-template-edit-settings
    *ngIf="currentEditMode === EditModes.settings"
    [(documentTemplate)]="documentTemplate"
    (unsavedChanges)="unsavedChanges = true"
    [documentTemplateErrors]="documentTemplateErrors">
  </app-document-template-edit-settings>

  <app-document-template-edit-sections
    *ngIf="currentEditMode === EditModes.sections"
    [(documentTemplate)]="documentTemplate"
    (unsavedChanges)="unsavedChanges = true"
    [documentTemplateErrors]="documentTemplateErrors"
    [orgConfig]="orgConfigService.getOrganizationConfig()">
  </app-document-template-edit-sections>

  <app-document-template-edit-linked-products
    *ngIf="currentEditMode === EditModes.linkedProducts"
    [documentTemplateId]="documentTemplate.id">
  </app-document-template-edit-linked-products>

  <div class="alert alert-success alert-dismissible" role="alert" *ngIf="documentTemplateSuccessMessage">
    {{ documentTemplateSuccessMessage }}
    <button type="button" class="close" (click)="documentTemplateSuccessMessage = ''">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="alert alert-danger alert-dismissible" role="alert" *ngIf="documentTemplateErrorMessage">
    {{ documentTemplateErrorMessage }}
    <button type="button" class="close" (click)="documentTemplateErrorMessage = ''">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="alert alert-info" role="alert" *ngIf="loadingTemplate">
    Loading...
  </div>
</div>
